import React, { useEffect, useState } from "react";
import { useMotionValue, animate } from "framer-motion";

/**
 * Animated number that smoothly tweens from previous to next value.
 * `format` receives the current numeric value and must return a string.
 */
export default function AnimatedNumber({ value, format, duration = 0.8 }) {
  const mv = useMotionValue(0);
  const [display, setDisplay] = useState(() => format(0));

  useEffect(() => {
    const controls = animate(mv, value, {
      duration,
      ease: [0.32, 0.72, 0, 1],
      onUpdate: (v) => setDisplay(format(v)),
    });
    return () => controls.stop();
  }, [value, mv, format, duration]);

  return <span className="tabular-nums">{display}</span>;
}
